/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { skillsAddVersion } from "../funcs/skillsAddVersion.js";
import { skillsApproveAllSuggestions } from "../funcs/skillsApproveAllSuggestions.js";
import { skillsApproveSuggestion } from "../funcs/skillsApproveSuggestion.js";
import { skillsArchive } from "../funcs/skillsArchive.js";
import { skillsCreate } from "../funcs/skillsCreate.js";
import { skillsDismissSuggestion } from "../funcs/skillsDismissSuggestion.js";
import { skillsDistribute } from "../funcs/skillsDistribute.js";
import { skillsGet } from "../funcs/skillsGet.js";
import { skillsGetShared } from "../funcs/skillsGetShared.js";
import { skillsLink } from "../funcs/skillsLink.js";
import { skillsList } from "../funcs/skillsList.js";
import { skillsListDistributions } from "../funcs/skillsListDistributions.js";
import { skillsListFeedback } from "../funcs/skillsListFeedback.js";
import { skillsListLinks } from "../funcs/skillsListLinks.js";
import { skillsListSuggestionFeedback } from "../funcs/skillsListSuggestionFeedback.js";
import { skillsListSuggestions } from "../funcs/skillsListSuggestions.js";
import { skillsListTags } from "../funcs/skillsListTags.js";
import { skillsListUnknownActivations } from "../funcs/skillsListUnknownActivations.js";
import { skillsListVersions } from "../funcs/skillsListVersions.js";
import { skillsRestoreVersion } from "../funcs/skillsRestoreVersion.js";
import { skillsShare } from "../funcs/skillsShare.js";
import { skillsTriggerSuggestion } from "../funcs/skillsTriggerSuggestion.js";
import { skillsUndistribute } from "../funcs/skillsUndistribute.js";
import { skillsUnlink } from "../funcs/skillsUnlink.js";
import { skillsUnshare } from "../funcs/skillsUnshare.js";
import { skillsUpdate } from "../funcs/skillsUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ApproveAllSkillSuggestionsResult } from "../models/components/approveallskillsuggestionsresult.js";
import { ApproveSkillSuggestionResult } from "../models/components/approveskillsuggestionresult.js";
import { GetSkillResult } from "../models/components/getskillresult.js";
import { ListSkillSuggestionFeedbackResult } from "../models/components/listskillsuggestionfeedbackresult.js";
import { ListSkillTagsResult } from "../models/components/listskilltagsresult.js";
import { RecordSkillResult } from "../models/components/recordskillresult.js";
import { Skill } from "../models/components/skill.js";
import { SkillDistribution } from "../models/components/skilldistribution.js";
import { SkillEditSuggestion } from "../models/components/skilleditsuggestion.js";
import { SkillLink } from "../models/components/skilllink.js";
import { SkillShareLink } from "../models/components/skillsharelink.js";
import {
  AddSkillVersionRequest,
  AddSkillVersionSecurity,
} from "../models/operations/addskillversion.js";
import {
  ApproveAllSkillSuggestionsRequest,
  ApproveAllSkillSuggestionsSecurity,
} from "../models/operations/approveallskillsuggestions.js";
import {
  ApproveSkillSuggestionRequest,
  ApproveSkillSuggestionSecurity,
} from "../models/operations/approveskillsuggestion.js";
import {
  ArchiveSkillRequest,
  ArchiveSkillSecurity,
} from "../models/operations/archiveskill.js";
import {
  CreateSkillRequest,
  CreateSkillSecurity,
} from "../models/operations/createskill.js";
import {
  DismissSkillSuggestionRequest,
  DismissSkillSuggestionSecurity,
} from "../models/operations/dismissskillsuggestion.js";
import {
  DistributeSkillRequest,
  DistributeSkillSecurity,
} from "../models/operations/distributeskill.js";
import {
  GetSharedSkillRequest,
  GetSharedSkillResponse,
} from "../models/operations/getsharedskill.js";
import {
  GetSkillRequest,
  GetSkillSecurity,
} from "../models/operations/getskill.js";
import {
  LinkSkillRequest,
  LinkSkillSecurity,
} from "../models/operations/linkskill.js";
import {
  ListSkillDistributionsRequest,
  ListSkillDistributionsResponse,
  ListSkillDistributionsSecurity,
} from "../models/operations/listskilldistributions.js";
import {
  ListSkillFeedbackRequest,
  ListSkillFeedbackResponse,
  ListSkillFeedbackSecurity,
} from "../models/operations/listskillfeedback.js";
import {
  ListSkillLinksRequest,
  ListSkillLinksResponse,
  ListSkillLinksSecurity,
} from "../models/operations/listskilllinks.js";
import {
  ListSkillsRequest,
  ListSkillsResponse,
  ListSkillsSecurity,
} from "../models/operations/listskills.js";
import {
  ListSkillSuggestionFeedbackRequest,
  ListSkillSuggestionFeedbackSecurity,
} from "../models/operations/listskillsuggestionfeedback.js";
import {
  ListSkillSuggestionsRequest,
  ListSkillSuggestionsResponse,
  ListSkillSuggestionsSecurity,
} from "../models/operations/listskillsuggestions.js";
import {
  ListSkillTagsRequest,
  ListSkillTagsSecurity,
} from "../models/operations/listskilltags.js";
import {
  ListSkillVersionsRequest,
  ListSkillVersionsResponse,
  ListSkillVersionsSecurity,
} from "../models/operations/listskillversions.js";
import {
  ListUnknownSkillActivationsRequest,
  ListUnknownSkillActivationsResponse,
  ListUnknownSkillActivationsSecurity,
} from "../models/operations/listunknownskillactivations.js";
import {
  RestoreSkillVersionRequest,
  RestoreSkillVersionSecurity,
} from "../models/operations/restoreskillversion.js";
import {
  ShareSkillRequest,
  ShareSkillSecurity,
} from "../models/operations/shareskill.js";
import {
  TriggerSkillSuggestionRequest,
  TriggerSkillSuggestionSecurity,
} from "../models/operations/triggerskillsuggestion.js";
import {
  UndistributeSkillRequest,
  UndistributeSkillSecurity,
} from "../models/operations/undistributeskill.js";
import {
  UnlinkSkillRequest,
  UnlinkSkillSecurity,
} from "../models/operations/unlinkskill.js";
import {
  UnshareSkillRequest,
  UnshareSkillSecurity,
} from "../models/operations/unshareskill.js";
import {
  UpdateSkillRequest,
  UpdateSkillSecurity,
} from "../models/operations/updateskill.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class Skills extends ClientSDK {
  /**
   * addVersion skills
   *
   * @remarks
   * Record an uploaded SKILL.md as a version of an existing skill. The implementation requires the skills product feature and skill write scope, and returns the existing canonical version as a no-op when appropriate.
   */
  async addVersion(
    request: AddSkillVersionRequest,
    security?: AddSkillVersionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RecordSkillResult> {
    return unwrapAsync(skillsAddVersion(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * approveAllSuggestions skills
   *
   * @remarks
   * Snapshot and independently process selected skill edit suggestions, or every open suggestion when no IDs are supplied. One conflict or failure does not stop the remaining approvals.
   */
  async approveAllSuggestions(
    request?: ApproveAllSkillSuggestionsRequest | undefined,
    security?: ApproveAllSkillSuggestionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ApproveAllSkillSuggestionsResult> {
    return unwrapAsync(skillsApproveAllSuggestions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * approveSuggestion skills
   *
   * @remarks
   * Approve an open skill edit suggestion, optionally replacing its proposed SKILL.md content or taking only a subset of its proposed changes. Stale suggestions are superseded instead.
   */
  async approveSuggestion(
    request: ApproveSkillSuggestionRequest,
    security?: ApproveSkillSuggestionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ApproveSkillSuggestionResult> {
    return unwrapAsync(skillsApproveSuggestion(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * archive skills
   *
   * @remarks
   * Idempotently archive a skill. The implementation requires the skills product feature and skill write scope. Repeated requests for the same skill succeed without creating another state transition.
   */
  async archive(
    request: ArchiveSkillRequest,
    security?: ArchiveSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(skillsArchive(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * create skills
   *
   * @remarks
   * Record an uploaded SKILL.md. The implementation requires the skills product feature and skill write scope, and may create a skill, add a version to an existing skill, or return an existing canonical version as a no-op.
   */
  async create(
    request: CreateSkillRequest,
    security?: CreateSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RecordSkillResult> {
    return unwrapAsync(skillsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * dismissSuggestion skills
   *
   * @remarks
   * Idempotently dismiss an open skill edit suggestion. Approved and superseded suggestions conflict.
   */
  async dismissSuggestion(
    request: DismissSkillSuggestionRequest,
    security?: DismissSkillSuggestionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SkillEditSuggestion> {
    return unwrapAsync(skillsDismissSuggestion(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * distribute skills
   *
   * @remarks
   * Create or update the active distribution of a skill to exactly one plugin or assistant. Repeating the request for the same target updates the version pin or is a no-op.
   */
  async distribute(
    request: DistributeSkillRequest,
    security?: DistributeSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SkillDistribution> {
    return unwrapAsync(skillsDistribute(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * get skills
   *
   * @remarks
   * Get an active skill and its latest version. The implementation requires the skills product feature and skill read scope.
   */
  async get(
    request: GetSkillRequest,
    security?: GetSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetSkillResult> {
    return unwrapAsync(skillsGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getShared skills
   *
   * @remarks
   * Fetch the publicly shared view of a skill by its share token. This endpoint is unauthenticated and only ever exposes the skill name, display name, summary, and latest content.
   */
  async getShared(
    request: GetSharedSkillRequest,
    options?: RequestOptions,
  ): Promise<GetSharedSkillResponse> {
    return unwrapAsync(skillsGetShared(
      this,
      request,
      options,
    ));
  }

  /**
   * link skills
   *
   * @remarks
   * Link a skill to exactly one MCP surface that serves it over MCP. Repeating the request for the same skill and target updates the version pin or is a no-op. Requires the skills-over-mcp rollout for the organization.
   */
  async link(
    request: LinkSkillRequest,
    security?: LinkSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SkillLink> {
    return unwrapAsync(skillsLink(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * list skills
   *
   * @remarks
   * List active skills in the project. The implementation requires the skills product feature and skill read scope.
   */
  async list(
    request?: ListSkillsRequest | undefined,
    security?: ListSkillsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListSkillsResponse, { cursor: string }>> {
    return unwrapResultIterator(skillsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listDistributions skills
   *
   * @remarks
   * List active plugin skill distributions for the current project.
   */
  async listDistributions(
    request?: ListSkillDistributionsRequest | undefined,
    security?: ListSkillDistributionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListSkillDistributionsResponse, { cursor: string }>> {
    return unwrapResultIterator(skillsListDistributions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listFeedback skills
   *
   * @remarks
   * List outcome counts, collection metrics, volume, and recent resolved feedback for a skill. Name-only feedback is excluded.
   */
  async listFeedback(
    request: ListSkillFeedbackRequest,
    security?: ListSkillFeedbackSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListSkillFeedbackResponse, { cursor: string }>> {
    return unwrapResultIterator(skillsListFeedback(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listLinks skills
   *
   * @remarks
   * List the current project's live skill links, limited to MCP surfaces the caller can read. Requires the skills-over-mcp rollout for the organization.
   */
  async listLinks(
    request?: ListSkillLinksRequest | undefined,
    security?: ListSkillLinksSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListSkillLinksResponse, { cursor: string }>> {
    return unwrapResultIterator(skillsListLinks(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listSuggestionFeedback skills
   *
   * @remarks
   * List the agent feedback cited as the reason for one proposed change, newest first.
   */
  async listSuggestionFeedback(
    request: ListSkillSuggestionFeedbackRequest,
    security?: ListSkillSuggestionFeedbackSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSkillSuggestionFeedbackResult> {
    return unwrapAsync(skillsListSuggestionFeedback(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listSuggestions skills
   *
   * @remarks
   * List open skill edit suggestions in the project, newest first. The implementation requires the skills product feature and skill read scope.
   */
  async listSuggestions(
    request?: ListSkillSuggestionsRequest | undefined,
    security?: ListSkillSuggestionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListSkillSuggestionsResponse, { cursor: string }>> {
    return unwrapResultIterator(skillsListSuggestions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listTags skills
   *
   * @remarks
   * List distinct tags used by active skills in the project. The implementation requires the skills product feature and skill read scope.
   */
  async listTags(
    request?: ListSkillTagsRequest | undefined,
    security?: ListSkillTagsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSkillTagsResult> {
    return unwrapAsync(skillsListTags(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listUnknownActivations skills
   *
   * @remarks
   * List terminal skill activations that could not be attributed to a skill version.
   */
  async listUnknownActivations(
    request?: ListUnknownSkillActivationsRequest | undefined,
    security?: ListUnknownSkillActivationsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<ListUnknownSkillActivationsResponse, { cursor: string }>
  > {
    return unwrapResultIterator(skillsListUnknownActivations(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listVersions skills
   *
   * @remarks
   * List immutable versions of an active skill, newest first. The implementation requires the skills product feature and skill read scope.
   */
  async listVersions(
    request: ListSkillVersionsRequest,
    security?: ListSkillVersionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListSkillVersionsResponse, { cursor: string }>> {
    return unwrapResultIterator(skillsListVersions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * restoreVersion skills
   *
   * @remarks
   * Restore a historical valid version as the skill's current version without changing the immutable version record or explicit distribution pins.
   */
  async restoreVersion(
    request: RestoreSkillVersionRequest,
    security?: RestoreSkillVersionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RecordSkillResult> {
    return unwrapAsync(skillsRestoreVersion(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * share skills
   *
   * @remarks
   * Create a public share link for a skill. Repeated requests return the existing active link, so each skill has at most one active share token.
   */
  async share(
    request: ShareSkillRequest,
    security?: ShareSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SkillShareLink> {
    return unwrapAsync(skillsShare(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * triggerSuggestion skills
   *
   * @remarks
   * Manually run suggestion analysis for a skill, bypassing automatic feedback and efficacy thresholds while preserving the one-open-suggestion invariant.
   */
  async triggerSuggestion(
    request: TriggerSkillSuggestionRequest,
    security?: TriggerSkillSuggestionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(skillsTriggerSuggestion(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * undistribute skills
   *
   * @remarks
   * Revoke a skill's active distribution to exactly one plugin or assistant. Repeated requests are a no-op.
   */
  async undistribute(
    request: UndistributeSkillRequest,
    security?: UndistributeSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(skillsUndistribute(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * unlink skills
   *
   * @remarks
   * Remove a skill link so its MCP surface stops serving the skill through it. Removing a link that is already gone is a no-op. Requires the skills-over-mcp rollout for the organization.
   */
  async unlink(
    request: UnlinkSkillRequest,
    security?: UnlinkSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(skillsUnlink(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * unshare skills
   *
   * @remarks
   * Revoke a skill's active public share link. Repeated requests are a no-op.
   */
  async unshare(
    request: UnshareSkillRequest,
    security?: UnshareSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(skillsUnshare(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * update skills
   *
   * @remarks
   * Rename an active skill or update its display name, summary, and tags. The implementation requires the skills product feature and skill write scope.
   */
  async update(
    request: UpdateSkillRequest,
    security?: UpdateSkillSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Skill> {
    return unwrapAsync(skillsUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
